/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022 (original work) Open Assessment Technologies SA
 *
 */

import request, { getEndpointUrl } from '@/core/apiRequest/apiRequest';
import _ from 'lodash';
import globalFilterTermsProvider from '../../../services/globalFilterTermsProvider';

export const searchUsers = ({ pageSize, pageNumber, sort, filters, hierarchyId, includeParentHierarchies } = {}) => {
    let textSearch;
    let terms = []
    const globalTerms = globalFilterTermsProvider.provideTerms();
    if (filters?.search?.length) {
        textSearch = {
            type: 'partialSearch',
            fields: ['login', 'name', 'email'],
            value: filters.search,
        };
    }
    if (filters?.terms) {
        for (const field in filters.terms) {
            terms.push({
                type: 'terms',
                field,
                values: filters.terms[field],
            });
        }
    }

    if (globalTerms) {
        if (terms.length) {
            terms.map(term => {
                if (globalTerms[term.field]) {
                    term.values = term.values.concat(globalTerms[term.field]);
                }
                return term;
            });
        } else {
            for (const field in globalTerms) {
                if(globalTerms[field].length) {
                    terms.push({
                        type: 'terms',
                        field,
                        values: globalTerms[field]
                    });
                }
            }
        }
    }

    const sorting = _.isEmpty(sort) ? {} : { sort };

    const queryParams = { groups: true };
    if (hierarchyId) {
        queryParams.hierarchyId = hierarchyId;
    }
    if (typeof includeParentHierarchies !== 'undefined') {
        queryParams.includeParentHierarchies = includeParentHierarchies;
    }
    return request(getEndpointUrl('searchUsers', {}, queryParams), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            pageSize,
            pageNumber,
            ...sorting,
            textSearch,
            filters: terms
        })
    });
};

export const createUser = user =>
    request(getEndpointUrl('users'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(user)
    });

export const deleteUser = login =>
    request(getEndpointUrl('user', { login }), {
        method: 'DELETE'
    });

export const updateUser = (login, body) =>
    request(getEndpointUrl('user', { login }), {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });

export const partialUpdateUser = (login, body) =>
    request(getEndpointUrl('user', { login }), {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });

export const getUser = login =>
    request(getEndpointUrl('user', { login }), {
        method: 'GET'
    });

export const getUserGroups = login =>
    request(getEndpointUrl('user.groups', { login }, { users: true, activity: true }), {
        method: 'GET'
    });

export const setUserGroups = (login, addedGroups, removedGroups) =>
    request(getEndpointUrl('user.groups', { login }), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            add: addedGroups.map(group => ({ role: group.groupRole, groupId: group.groupId })),
            remove: removedGroups
        })
    });
